module.exports = __webpack_public_path__ + "static/img/logo9.e4be999d.png";